import * as React from 'react';
import { ArticleAuthor } from '../../types/ArticleAuthor';
import styles from './business-article-bio-block.module.scss';
import IconAuthorAvatar from './IconAuthorAvatar';
interface Props {
    articleAuthor: ArticleAuthor | undefined;
}
const ArticleBioBlock = (props: Props) => {
    const { articleAuthor } = props;
    const renderAuthorAvatar = () => {
        if (!articleAuthor?.leadImage || articleAuthor?.leadImage === '') {
            return <IconAuthorAvatar />;
        }
        return <div className={styles.businessArticleLeadImage} style={{ backgroundImage: `url('${articleAuthor?.leadImage}')` }} />;
    };
    return (
        <div className={styles.businessArticleBioContainer}>
            <div className={styles.businessArticleAuthorAvatar}>{renderAuthorAvatar()}</div>
            <div className={styles.businessArticleInfo}>
                <span className={styles.writtenBy}>Written by</span>
                <div className={styles.name}>{articleAuthor?.name}</div>
                <div className={styles.bio}>{articleAuthor?.bio}</div>
            </div>
        </div>
    );
};

export default ArticleBioBlock;
